<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
<!--                            buat dialog dengan input tanggal-->
                            <Dialog header="Tolak User" :visible="displayBasic" :modal="true" :closable="false" :style="{ width: '50vw' }">
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="keterangan"
                                            value="Keterangan Tolak User"
                                        />
                                        <Input
                                            id="keterangan"
                                            v-model="keterangan"
                                            type="text"
                                            placeholder=""
                                            class="mt-1 block w-full"
                                        />
                                    </div>
                                </div>
                                <template #footer>
                                    <div class="p-d-flex p-jc-end">
                                        <Button label="Batal" @click="displayBasic=false" />
                                        <Button label="Tolak" @click="tolakUser" />
                                    </div>
                                </template>
                            </Dialog>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <!-- <ButtonLinkAdd
                                            :url="
                                                route('penyedia.create')
                                            "
                                            class="mr-1"
                                            >Tambah</ButtonLinkAdd
                                        > -->
                                        <ButtonAdd
                                            :disabled="
                                                selected_penyedia.length == 0 ||
                                                !allow_to_proceed
                                            "
                                            label="Verifikasi"
                                            @click="verif($event)"
                                            class="mr-1"
                                        />
                                        <ButtonEdit
                                            :disabled="
                                                selected_penyedia.length == 0 ||
                                                !allow_to_proceed
                                            "
                                            label="Tolak User"
                                            @click="tolak($event)"
                                            class="mr-1"
                                        />
                                        <!-- <ButtonLinkEdit
                                            :disabled="
                                                selected_penyedia.length != 1
                                            "
                                            :url="
                                                route('penyedia.edit', {
                                                    id: selected_penyedia_id,
                                                })
                                            "
                                            class="mr-1"
                                            >Edit</ButtonLinkEdit
                                        > -->
                                    </template>
                                    <template #end>
                                    </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedpenyedia"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import EzDataTable from "@/Components/EzDataTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import ButtonLinkAdd from "@/Components/ButtonLinkAdd";
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import ButtonLinkShow from "@/Components/ButtonLinkShow";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import ButtonAdd from "@/Components/ButtonAdd.vue";
import Dialog from 'primevue/dialog';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        EzDataTable,
        Toolbar,
        Button,
        ButtonLinkAdd,
        ButtonLinkEdit,
        ButtonLinkShow,
        ButtonDelete,
        ButtonEdit,
        ButtonAdd,
        Dialog,
        JetLabel,
        Input,
    },
    data() {
        return {
            ezdtConfig: {
                dtHeader: "Daftar User Penyedia",
                globalFilter: ['username','fullname','email','identity'],
                sortBy: "created_at",
                defineCols: [
                    {
                        field: "is_verified",
                        header: "Verified",
                        style: "min-width: 5rem",
                        isFrozen: true,
                        col_type: "boolean",
                    },
                    //verifikasi email
                    {
                        field: "email_verified_at",
                        header: "Email Verified",
                        style: "min-width: 5rem",
                        isFrozen: true,
                        col_type: "date",
                    },
                    {
                        field: "fullname",
                        header: "Nama",
                        style: "min-width: 20rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "identity",
                        header: "NPWP",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "username",
                        header: "username",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "email",
                        header: "Email",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_jenis_pekerjaan",
                        header: "Jenis Pekerjaan",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                ],
                dtSourceApiRoute: {
                    list: "penyedia.dataUser",
                    // show: "penyedia.show",
                    // edit: "penyedia.edit",
                    // destroy: "penyedia.destroy",
                },
            },
            selected_penyedia: [],
            selected_penyedia_id: 0,
            allow_to_proceed: true,
            displayBasic: false,
            tanggal: null,
            keterangan: null,
            lokasi: null,
        };
    },
    methods: {
        loadEzData: function () {
            // this.allow_to_proceed = false;
            this.$refs.ezdt.loadData();
        },
        getSelectedpenyedia: function (data) {
            this.selected_penyedia = data;
            this.selected_penyedia_id = 0;
            if (data.length == 1) {
                this.selected_penyedia_id = data[0]["user_id"];
                console.log(this.selected_penyedia_id);
            }
        },
        tambah: function (event) {
            //
        },
        edit: function (event) {
            //
        },

        verif: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Verifikasi (" +
                    this.selected_penyedia.length +
                    ") selected record ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-info",
                accept: () => {
                    let ids = [];
                    let cek = true;
                    this.selected_penyedia.forEach(function (item, index) {
                        ids.push(item.id);
                        // cek jika ada item.status is verifikasi so return toast
                        if(item.is_verified == '1'){
                           cek = false;
                        }
                    });
                    // update data
                    if (cek == false){
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: 'data sudah diverifikasi',
                            life: 3000,
                        });
                        return false;
                    }
                    axios
                        .post(route("penyedia.verifikasiUser"), {
                            ids: ids,
                            is_verified: 1,
                            keterangan: '-',
                        })
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Success",
                                detail: Pesan.success,
                                life: 3000,
                            });
                            this.loadEzData();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: Pesan.error,
                                life: 3000,
                            });
                        });
                },
                reject: () => {
                    //
                },
            });

        },
        tolak: function (event) {

            let ids = [];
            this.selected_penyedia.forEach(function (item, index) {
                ids.push(item.id);
            });
            // tampilkan modal
            this.displayBasic = true;

        },
        tolakUser: function (event) {
            let ids = [];
            this.selected_penyedia.forEach(function (item, index) {
                ids.push(item.id);
            });
            axios
                .post(route("penyedia.tolakUser"), {
                    ids: ids,
                    keterangan: this.keterangan,
                })
                .then((response) => {

                    this.loadEzData();
                    this.displayBasic = false;
                })
                .catch((error) => {
                    this.loadEzData();
                    this.displayBasic = false;
                });

        },
    },
});
</script>
